import * as moment from 'moment'
import { FeedbackModel } from '../admin/models/FeedbackModels';
import api from '../utils/api';
import { ErrorModel } from '../common/models/CommonModels';
import { GiveFeedbackModel } from '../feedback/models/GiveFeedbackModels';
import { PagingFilter, PagedResultData } from '../common/models/PagingModels';

export const wrapPaging = (apiCall: string, pagingFilter: PagingFilter) => {
    const paging = `PageNumber=${pagingFilter.currentPage}&PageSize=${pagingFilter.rowsPerPage}`;

    return apiCall + paging;
}

export const fetchFeedback = (paging?: PagingFilter): Promise<PagedResultData<FeedbackModel[]> | undefined> => {

    let endpoint = "api/feedback?";
    if (paging) {
        endpoint = wrapPaging(endpoint, paging);
    }

    return api.get(endpoint).then(response => {
        if (response.status === 200) {
            const data = <PagedResultData<FeedbackModel[]>>response.data;
            return data;
        }
        return undefined;
    });
}

export const addFeedback = (data: GiveFeedbackModel): Promise<boolean> => {
    return api.post("api/feedback", data).then(response => {
        if (response.status === 200) {
            return true;
        }

        return false;
    });
}

export const setFeedbackRead = (feedbackId: string): Promise<boolean> => {
    return api.patch("api/feedback/setread", { feedbackId }).then(response => {
        return response.status === 200;
    });
}


// WEBPACK FOOTER //
// ./src/api/feedbackApi.ts